import styled, {css} from 'styled-components'

export const StyledFilterBar = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: ${spacing * 2}px;
        width: 100%;
    `
)

export const StyledFilterChipList = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing * 1.5}px;
        flex: 1;
    `
)

export const StyledFilterChip = styled.button(
    ({theme: {palette, spacing, typography}}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${spacing * 1}px;
        padding: ${spacing * 1}px ${spacing * 2}px;
        background: ${palette.primary[50]};
        color: ${palette.primary[700]};
        border: 1px solid ${palette.primary[200]};
        border-radius: 999px;
        cursor: pointer;
        ${typography.textXs};
        font-weight: 500;

        &:hover {
            background: ${palette.primary[100]};
        }
    `
)

export const StyledClearAll = styled.button(
    ({theme: {palette, typography, spacing}}) => css`
        background: none;
        border: none;
        padding: ${spacing * 1}px ${spacing * 2}px;
        cursor: pointer;
        color: ${palette.neutral[600]};
        ${typography.textXs};
        font-weight: 500;
        text-decoration: underline;

        &:hover {
            color: ${palette.neutral[800]};
        }
    `
)
